import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { PageWrapper, Loader, Alert, Pagination } from "../../components";
import Actions, { thunks } from "../../redux/modules/appUsers";
import { debounce } from 'lodash';

class Users extends React.Component {
  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(thunks.getUsers());
  }

  onSearchTextChange = debounce((e) => {
    const { value } = e.target ? e.target : "";
    const { updateProperty, dispatch } = this.props;
    updateProperty("searchText", value);
    if (value) {
      dispatch(thunks.searchUsers(value));
    } else {
      dispatch(thunks.getUsers());
    }
  }, 300);

  editUser = (user, id) => {
    const { dispatch } = this.props;
    const a = {
      userType: id,
      userId: user.id,
    };
    const body = { ...user };
    dispatch(thunks.editUser(a));
  };

  onNext = () => {
    const { dispatch } = this.props;
    dispatch(thunks.loadMoreUsers());
  };

  viewUser = (user) => {
    this.props.history.push(`/app-user/${user.id}`);
  };

  render() {
    const { list, loading, error, updateProperty, nextPageToken } = this.props;

    return (
      <PageWrapper title="Users">
        <Loader show={loading} />
        <Alert
          show={!!error}
          onHide={() => updateProperty("error", "")}
          title="Users"
          message={error}
        />
        <div className="animated fadeIn">
          <div className="row mt-3">
            <div className="col-md-12">
              <div className="card">
                <div className="card-body">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Search</label>
                      <input
                        placeholder="Enter search text"
                        className="form-control"
                        onChange={this.onSearchTextChange}
                      />
                    </div>
                  </div>
                  <div className="table-responsive">
                    <table className="table">
                      <thead>
                        <tr>
                          <th>ID</th>
                          <th>Created Date</th>
                          <th>Name</th>
                          <th>Phone</th>
                          <th />
                          <th />
                          <th />
                        </tr>
                      </thead>
                      <tbody>
                        {list.length ? (
                          list.map((user) => (
                            <tr key={user.id}>
                              <td>{user.id}</td>
                              <td>{user.createdDate}</td>
                              <td>{user.name}</td>
                              <td>
                                {"+" +
                                  user.countryCode +
                                  "-" +
                                  user.phoneNumber}
                              </td>
                              <td>
                                <button
                                  title="View User"
                                  className="btn btn-xs btn-info"
                                  onClick={() => this.viewUser(user)}
                                >
                                  <i className="fa fa-eye" />
                                </button>
                              </td>
                              <td>
                                {user.userType != 3 && (
                                  <button
                                    title="View User"
                                    className="btn btn-xs btn-outline-primary"
                                    onClick={() => this.editUser(user, 3)}
                                  >
                                    Add to Franchise Owner
                                  </button>
                                )}
                              </td>
                              <td>
                                {user.userType != 4 && (
                                  <button
                                    title="View User"
                                    className="btn btn-xs btn-outline-success"
                                    onClick={() => this.editUser(user, 4)}
                                  >
                                    Add to Sales Man
                                  </button>
                                )}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="5" className="text-center">
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                    <Pagination
                      nextPageToken={nextPageToken}
                      onNext={this.onNext}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </PageWrapper>
    );
  }
}

const mapStateToProps = ({
  appUsers: { loading, error, list, nextPageToken },
}) => ({
  loading,
  error,
  list,
  nextPageToken,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch,
  updateProperty: bindActionCreators(Actions, dispatch).updateProperty,
  reset: bindActionCreators(Actions, dispatch).reset,
});

export default connect(mapStateToProps, mapDispatchToProps)(Users);
